import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { UIService } from '../../../../app/shared/services';

@Component({
  selector: 'vi-logo',
  templateUrl: 'logo.component.html',
  styleUrls: ['logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViLogoComponent implements OnInit {
  @Input() isRsa: Boolean;
  logoUrl: string;

  constructor(public uiService: UIService) {}

  ngOnInit(): void {
    this.logoUrl = this.getLogoUrl();
  }

  getLogoUrl(): string {
    if (this.isRsa) {
      return './assets/img/viguide-rsa-logo.svg';
    }
    return './assets/img/viguide-name.svg';
  }
}
